import { useModal } from '@shared/model/useModal';

export const useCalendarSyncModal = () => useModal('calendar-sync')
